import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Colors } from "../../../constants/styles";
import { Loader, SearchBar } from "../../../components";
import { addDays, diffDays, round2 } from "../../../constants/helper";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  ButtonGroup,
  Button,
  Snackbar,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  FormControlLabel,
  Checkbox,
  DialogContent,
  Autocomplete,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import DatePicker from "react-datepicker";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SearchIcon from "@mui/icons-material/Search";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../hooks/useScreenWidth";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const UbahPembelian = () => {
  const screenSize = useScreenWidth();
  const { user, setting, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [openUbah, setOpenUbah] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isInputStok, setIsInputStok] = useState(false);

  // Data Pembelian
  const [noNotaPembelian, setNoNotaPembelian] = useState("");
  const [tglPembelian, setTglPembelian] = useState(null);
  const [jumlahItem, setJumlahItem] = useState("0");

  // Data Supplier
  const [kodeSupplier, setKodeSupplier] = useState("");
  const [namaSupplier, setNamaSupplier] = useState("");
  const [alamatSupplier, setAlamatSupplier] = useState("");
  const [kodeCOA, setKodeCOA] = useState("");
  const [keterangan, setKeterangan] = useState("");

  // Data Total
  const [subtotal, setSubtotal] = useState("0");
  const [potongan, setPotongan] = useState("0");
  const [isPpn, setIsPpn] = useState(false);
  const [total, setTotal] = useState("0");
  const [ppnPersen, setPpnPersen] = useState("0");
  const [ppnTotal, setPpnTotal] = useState("0");
  const [kembali, setKembali] = useState("0");

  // Data Pembelian Kredit
  const [tipePembelian, setTipePembelian] = useState("TUNAI");
  const [lamaKredit, setLamaKredit] = useState("");
  const [tglJatuhTempo, setTglJatuhTempo] = useState(null);

  // Data Pembelian Child
  const [idPembelianChild, setIdPembelianChild] = useState("");
  const [pilihStok, setPilihStok] = useState("");
  const [kodeStok, setKodeStok] = useState("");
  const [namaStok, setNamaStok] = useState("");
  const [quantityLama, setQuantityLama] = useState("0");
  const [quantity, setQuantity] = useState("0");
  const [hargaSatuan, setHargaSatuan] = useState("0");
  const [discountPersen1, setDiscountPersen1] = useState("0");
  const [discount1, setDiscount1] = useState("0");
  const [discountPersen2, setDiscountPersen2] = useState("0");
  const [discount2, setDiscount2] = useState("0");
  const [discountPersen3, setDiscountPersen3] = useState("0");
  const [discount3, setDiscount3] = useState("0");
  const [discountPersen4, setDiscountPersen4] = useState("0");
  const [discount4, setDiscount4] = useState("0");
  const [discountPersen5, setDiscountPersen5] = useState("0");
  const [discount5, setDiscount5] = useState("0");
  const [hargaNetto, setHargaNetto] = useState("0");
  const [totalPembelianChild, setTotalPembelianChild] = useState("0");

  const [coas, setCoas] = useState([]);
  const [pembelianChilds, setPembelianChilds] = useState([]);

  const [stoks, setStoks] = useState([]);
  const [searchTermStok, setSearchTermStok] = useState("");
  const [openStok, setOpenStok] = useState(false);

  let [pageStok, setPageStok] = useState(0);
  const [limitStok, setLimitStok] = useState(10);
  const [pagesStok, setPagesStok] = useState(0);
  const [rowsStok, setRowsStok] = useState(0);
  const [queryStok, setQueryStok] = useState("");

  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleClickOpenUbah = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenUbah(true);
  };

  const handleCloseUbah = () => {
    setOpenUbah(false);
    setIdPembelianChild("");
    setKodeStok("");
    setNamaStok("");
    setQuantityLama("");
    setQuantity("");
    setHargaSatuan("");
    setDiscountPersen1("");
    setDiscount1("");
    setDiscountPersen2("");
    setDiscount2("");
    setDiscountPersen3("");
    setDiscount3("");
    setDiscountPersen4("");
    setDiscount4("");
    setDiscountPersen5("");
    setDiscount5("");
    setHargaNetto("");
    setTotalPembelianChild("");
  };

  const handleChangeStok = (e, p) => {
    setPageStok(p - 1);
  };

  const searchDataStok = (e) => {
    e.preventDefault();
    setPageStok(0);
    setSearchTermStok(queryStok);
  };

  const handleClickOpenStok = () => {
    setOpenStok(true);
  };

  const handleCloseStok = () => {
    setOpenStok(false);
  };

  const tipePembelianOption = ["TUNAI", "KREDIT"];
  let coaOptions = coas.map((coa) => ({
    label: `${coa.kodeCOA} - ${coa.namaCOA}`,
  }));

  useEffect(() => {
    getCoas();
    getPembelianById();
  }, []);

  useEffect(() => {
    getStoksData();
  }, [pageStok, searchTermStok]);

  const getCoas = async () => {
    const response = await axios.post(`${tempUrl}/coas`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCoas(response.data);
  };

  const getPembelianById = async () => {
    setLoading(true);
    const response = await axios.post(`${tempUrl}/pembelians/${id}`, {
      kodeCabang: user.cabang.id,
      _id: user.id,
      token: user.token,
    });
    // Data Pembelian
    setNoNotaPembelian(response.data.noNotaPembelian);
    setTglPembelian(new Date(response.data.tglPembelian));

    // Data Supplier
    setKodeSupplier(response.data.supplier.kodeSupplier);
    setNamaSupplier(response.data.supplier.namaSupplier);
    setAlamatSupplier(response.data.supplier.alamatSupplier);
    setKodeCOA(
      response.data.coa &&
        `${response.data.coa.kodeCOA} - ${response.data.coa.namaCOA}`,
    );
    setKeterangan(response.data.keterangan);

    // Data Total
    setSubtotal(response.data.subtotal);
    setPotongan(response.data.potongan);
    setTotal(response.data.total);
    if (response.data.ppnPersen > 0) {
      setIsPpn(true);
    }
    setPpnPersen(response.data.ppnPersen);
    setPpnTotal(response.data.ppnTotal);
    setKembali(response.data.kembali);

    // Data Pembelian Kredit
    setTipePembelian(response.data.tipePembelian);
    setLamaKredit(response.data.lamaKredit);
    setTglJatuhTempo(
      response.data.tglJatuhTempo
        ? new Date(response.data.tglJatuhTempo)
        : null,
    );

    const response2 = await axios.post(
      `${tempUrl}/pembelianChildsByPembelian`,
      {
        pembelianId: response.data.id,
        kodeCabang: user.cabang.id,
        _id: user.id,
        token: user.token,
      },
    );
    setPembelianChilds(response2.data);
    setJumlahItem(response2.data.length);
    setLoading(false);
  };

  const getStoksData = async () => {
    const response = await axios.post(
      `${tempUrl}/stoksPagination?search_query=${searchTermStok}&page=${pageStok}&limit=${limitStok}`,
      {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      },
    );
    setStoks(response.data.stoks);
    setPageStok(response.data.page);
    setPagesStok(response.data.totalPage);
    setRowsStok(response.data.totalRows);
  };

  const updatePembelian = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    let tempKodeCOA = null;
    if (kodeCOA !== "" && kodeCOA !== null) {
      tempKodeCOA = kodeCOA.split(" ", 1)[0];
    }

    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      try {
        setLoading(true);
        await axios.post(`${tempUrl}/updatePembelianTotal/${id}`, {
          tglPembelian,
          // Total
          subtotal,
          potongan,
          total,
          ppnTotal,
          kembali,

          // Data Pembelian Kredit
          tipePembelian,
          lamaKredit,
          tglJatuhTempo,
          kodeCOA: tempKodeCOA,

          userIdUpdate: user.id,
          _id: user.id,
          token: user.token,
        });
        setLoading(false);
        navigate(`/daftarPembelian/pembelian/${id}`);
      } catch (error) {
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const getFindStok = async (input) => {
    const response = await axios.post(`${tempUrl}/findStok`, {
      input,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setKodeStok(response.data.kodeStok);
    setNamaStok(response.data.namaStok);
  };

  const savePembelianChild = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      kodeStok.length !== 0 &&
      quantity.length !== 0 &&
      discountPersen1.length !== 0 &&
      discount1.length !== 0
    ) {
      // setLoading(true);
      try {
        // setLoading(true);
        let savedPembelianChild = await axios.post(
          `${tempUrl}/savePembelianChild`,
          {
            // Data Pembelian Child
            pembelianId: id,
            kodeStok,
            namaStok,
            quantity,
            hargaSatuan,
            discountPersen1,
            discount1,
            discountPersen2,
            discount2,
            discountPersen3,
            discount3,
            discountPersen4,
            discount4,
            discountPersen5,
            discount5,
            hargaNetto,
            totalPembelianChild,

            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          },
        );
        setIsInputStok(false);

        // Data Pembelian Child
        setPilihStok("");
        setKodeStok("");
        setNamaStok("");
        setQuantityLama("");
        setQuantity("");
        setHargaSatuan("");
        setDiscountPersen1("");
        setDiscount1("");
        setDiscountPersen2("");
        setDiscount2("");
        setDiscountPersen3("");
        setDiscount3("");
        setDiscountPersen4("");
        setDiscount4("");
        setDiscountPersen5("");
        setDiscount5("");
        setHargaNetto("");
        setTotalPembelianChild("");

        let findPembelianChild = await axios.post(
          `${tempUrl}/pembelianChildsByPembelian`,
          {
            pembelianId: id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          },
        );
        setPembelianChilds(findPembelianChild.data);
        setJumlahItem(findPembelianChild.data.length);

        let findPembelian = await axios.post(`${tempUrl}/pembelians/${id}`, {
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        });
        setSubtotal(findPembelian.data.subtotal);
        let tempPotongan = 0;
        setPotongan(tempPotongan);
        let tempTotal =
          parseFloat(tempPotongan) + parseFloat(findPembelian.data.subtotal);
        setTotal(tempTotal);
        let tempKembali = parseFloat(ppnTotal) - parseFloat(tempTotal);
        setKembali(tempKembali);
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const updatePembelianChild = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      kodeStok.length !== 0 &&
      quantity.length !== 0 &&
      discountPersen1.length !== 0 &&
      discount1.length !== 0 &&
      discountPersen2.length !== 0 &&
      discount2.length !== 0 &&
      discountPersen3.length !== 0 &&
      discount3.length !== 0 &&
      discountPersen4.length !== 0 &&
      discount4.length !== 0 &&
      discountPersen5.length !== 0 &&
      discount5.length !== 0
    ) {
      // setLoading(true);
      try {
        // setLoading(true);
        let savedPembelianChild = await axios.post(
          `${tempUrl}/updatePembelianChild/${idPembelianChild}`,
          {
            // Data Pembelian Child
            pembelianId: id,
            kodeStok,
            namaStok,
            quantityLama,
            quantity,
            hargaSatuan,
            discountPersen1,
            discount1,
            discountPersen2,
            discount2,
            discountPersen3,
            discount3,
            discountPersen4,
            discount4,
            discountPersen5,
            discount5,
            hargaNetto,
            totalPembelianChild,

            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          },
        );
        setIsInputStok(false);

        // Data Pembelian Child
        setPilihStok("");
        setKodeStok("");
        setNamaStok("");
        setQuantityLama("");
        setQuantity("");
        setHargaSatuan("");
        setDiscountPersen1("");
        setDiscount1("");
        setDiscountPersen2("");
        setDiscount2("");
        setDiscountPersen3("");
        setDiscount3("");
        setDiscountPersen4("");
        setDiscount4("");
        setDiscountPersen5("");
        setDiscount5("");
        setHargaNetto("");
        setTotalPembelianChild("");

        let findPembelianChild = await axios.post(
          `${tempUrl}/pembelianChildsByPembelian`,
          {
            pembelianId: id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          },
        );
        setPembelianChilds(findPembelianChild.data);
        setJumlahItem(findPembelianChild.data.length);

        let findPembelian = await axios.post(`${tempUrl}/pembelians/${id}`, {
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        });
        setSubtotal(findPembelian.data.subtotal);
        setPotongan("0");
        setPpnPersen("0");
        setPpnTotal("0");
        setTotal(findPembelian.data.subtotal);

        handleCloseUbah();
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const deletePembelianChild = async (
    e,
    pembelianChildId,
    quantity,
    totalPembelianChild,
  ) => {
    e.preventDefault();
    e.stopPropagation();

    const confirmed = window.confirm("Yakin ingin menghapus barang ini?");
    if (!confirmed) return;

    const form = e.currentTarget;
    if (form.checkValidity()) {
      // setLoading(true);
      try {
        // setLoading(true);
        let deletedPembelianChild = await axios.post(
          `${tempUrl}/deletePembelianChild/${pembelianChildId}`,
          {
            // Data Pembelian Child
            pembelianId: id,
            quantity,
            totalPembelianChild,

            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          },
        );
        setIsInputStok(false);

        let findPembelianChild = await axios.post(
          `${tempUrl}/pembelianChildsByPembelian`,
          {
            pembelianId: id,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          },
        );
        setPembelianChilds(findPembelianChild.data);
        setJumlahItem(findPembelianChild.data.length);

        let findPembelian = await axios.post(`${tempUrl}/pembelians/${id}`, {
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        });
        setSubtotal(findPembelian.data.subtotal);
        setPotongan("0");
        setPpnPersen("0");
        setPpnTotal("0");
        setTotal(findPembelian.data.subtotal);
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Transaksi</h3>
      <h5 style={{ fontWeight: 400 }}>Ubah Pembelian / Service</h5>
      <Typography sx={subTitleText}>
        Periode : {user.tutupperiode.namaPeriode}
      </Typography>
      <hr />
      <Form noValidate validated={validated}>
        <Card>
          <Card.Header>Data Pembelian</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Nota :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={noNotaPembelian}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tanggal <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          required
                          dateFormat="dd/MM/yyyy"
                          selected={tglPembelian}
                          minDate={new Date(user.tutupperiode.dariTanggal)}
                          maxDate={new Date(user.tutupperiode.sampaiTanggal)}
                          customInput={<Form.Control required />}
                          onChange={(date) => {
                            setTglPembelian(date);
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jumlah Item :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={jumlahItem}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Supplier</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Polisi :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={kodeSupplier} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={namaSupplier} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={alamatSupplier} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tipe Pembelian<b style={colorRed}>*</b>
                        {" :"}
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={tipePembelian}
                          onChange={(e) => {
                            setTipePembelian(e.target.value);

                            if (e.target.value === "TUNAI") {
                              setLamaKredit("");
                              setTglJatuhTempo(null);
                            } else {
                              setKodeCOA("");
                            }
                          }}
                        >
                          {tipePembelianOption.map((tipePembelian) => (
                            <option value={tipePembelian}>
                              {tipePembelian}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Lama Kredit{" "}
                        {tipePembelian === "KREDIT" ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required={tipePembelian === "KREDIT" && true}
                          value={lamaKredit}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setLamaKredit(tempValue);

                            let tempTglJatuhTempo = addDays(
                              tglPembelian,
                              parseInt(tempValue),
                            );
                            if (tipePembelian !== "TUNAI") {
                              setTglJatuhTempo(tempTglJatuhTempo);
                            }
                          }}
                          disabled={tipePembelian !== "KREDIT" && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. Jatuh Tempo{" "}
                        {tipePembelian === "KREDIT" ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          required={tipePembelian === "KREDIT" && true}
                          dateFormat="dd/MM/yyyy"
                          selected={tglJatuhTempo}
                          customInput={<Form.Control required />}
                          onChange={(date) => {
                            setTglJatuhTempo(date);

                            let tempLamaKredit = diffDays(tglPembelian, date);
                            setLamaKredit(tempLamaKredit);
                          }}
                          disabled={tipePembelian !== "KREDIT" && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode Kas{" "}
                        {tipePembelian === "TUNAI" ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={coaOptions}
                          renderInput={(params) => (
                            <TextField
                              error={error && kodeCOA.length === 0 && true}
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              setKodeCOA(value.label);
                            } else {
                              setKodeCOA("");
                            }
                          }}
                          value={kodeCOA}
                          disabled={tipePembelian === "KREDIT" && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Catatan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={keterangan} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="contained"
            color="info"
            sx={{
              bgcolor: "info.light",
              textTransform: "none",
              marginRight: 2,
              marginBottom: 2,
            }}
            // type="submit"
            onClick={() => {
              setIsInputStok(true);
              setQuantityLama("0");
              setQuantity("0");
              setHargaSatuan("0");
              setDiscountPersen1("0");
              setDiscount1("0");
              setDiscountPersen2("0");
              setDiscount2("0");
              setDiscountPersen3("0");
              setDiscount3("0");
              setDiscountPersen4("0");
              setDiscount4("0");
              setDiscountPersen5("0");
              setDiscount5("0");
              setHargaNetto("0");
              setTotalPembelianChild("0");
            }}
          >
            {"+ Input Transaksi"}
          </Button>
        </Box>
      </Form>

      <Form noValidate validated={validated} onSubmit={savePembelianChild}>
        <Card style={{ marginTop: 10 }}>
          <Card.Header>Detail Transaksi</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode / Barcode{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="5">
                        <Form.Control
                          required
                          value={pilihStok}
                          onChange={(e) => {
                            setPilihStok(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              // alert("Enter pressed on kodeStok");
                              getFindStok(e.target.value);
                            }
                          }}
                          style={{ textTransform: "uppercase" }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="2">
                        <Button
                          variant="contained"
                          onClick={() => handleClickOpenStok()}
                          disabled={isInputStok === true ? false : true}
                        >
                          <SearchIcon />
                        </Button>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Stok :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={namaStok} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Quantity{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={quantity}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onChange={(e) => {
                            let tempValue = e.target.value
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setQuantity(tempValue);

                            let tempTotalPembelianChild = Math.ceil(
                              parseFloat(tempValue) * parseFloat(hargaNetto),
                            );
                            setTotalPembelianChild(tempTotalPembelianChild);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Harga Satuan{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={hargaSatuan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onChange={(e) => {
                            let tempValue = e.target.value
                              .split(".")
                              .join("")
                              .replace(",", ".");
                            setHargaSatuan(tempValue);

                            let tempHargaNetto =
                              parseFloat(tempValue) -
                              parseFloat(discount1) -
                              parseFloat(discount2);
                            setHargaNetto(tempHargaNetto);

                            let tempTotalPembelianChild = Math.ceil(
                              parseFloat(quantity) * parseFloat(tempHargaNetto),
                            );
                            setTotalPembelianChild(tempTotalPembelianChild);

                            setDiscountPersen1("0");
                            setDiscount1("0");
                            setDiscountPersen2("0");
                            setDiscount2("0");
                            setDiscountPersen3("0");
                            setDiscount3("0");
                            setDiscountPersen4("0");
                            setDiscount4("0");
                            setDiscountPersen5("0");
                            setDiscount5("0");
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Disc / Pot. 1{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="3">
                        <NumericFormat
                          required
                          value={discountPersen1}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onChange={(e) => {
                            let tempValue = e.target.value
                              .split(".")
                              .join("")
                              .replace(",", ".");
                            setDiscountPersen1(tempValue);

                            let tempDiscount1 =
                              (parseFloat(hargaSatuan) * tempValue) / 100;
                            setDiscount1(tempDiscount1);

                            let temHargaNetto = round2(
                              parseFloat(hargaSatuan) -
                                parseFloat(tempDiscount1),
                            );
                            setHargaNetto(temHargaNetto);

                            let tempTotalPembelianChild = Math.ceil(
                              parseFloat(quantity) * parseFloat(temHargaNetto),
                            );
                            setTotalPembelianChild(tempTotalPembelianChild);

                            setDiscountPersen2("0");
                            setDiscount2("0");
                            setDiscountPersen3("0");
                            setDiscount3("0");
                            setDiscountPersen4("0");
                            setDiscount4("0");
                            setDiscountPersen5("0");
                            setDiscount5("0");
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="4">
                        <NumericFormat
                          required
                          value={discount1}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onChange={(e) => {
                            let tempValue = e.target.value
                              .split(".")
                              .join("")
                              .replace(",", ".");
                            setDiscount1(tempValue);

                            let tempDiscountPersen1 =
                              (parseFloat(tempValue) /
                                parseFloat(hargaSatuan)) *
                              100;
                            // limit to 2 decimals
                            tempDiscountPersen1 = Number(
                              tempDiscountPersen1.toFixed(2),
                            );
                            setDiscountPersen1(tempDiscountPersen1);

                            let temHargaNetto = round2(
                              parseFloat(hargaSatuan) - parseFloat(tempValue),
                            );
                            setHargaNetto(temHargaNetto);

                            let tempTotalPembelianChild = Math.ceil(
                              parseFloat(quantity) * parseFloat(temHargaNetto),
                            );
                            setTotalPembelianChild(tempTotalPembelianChild);

                            setDiscountPersen2("0");
                            setDiscount2("0");
                            setDiscountPersen3("0");
                            setDiscount3("0");
                            setDiscountPersen4("0");
                            setDiscount4("0");
                            setDiscountPersen5("0");
                            setDiscount5("0");
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Disc / Pot. 2{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="3">
                        <NumericFormat
                          required
                          value={discountPersen2}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onChange={(e) => {
                            let tempValue = e.target.value
                              .split(".")
                              .join("")
                              .replace(",", ".");
                            setDiscountPersen2(tempValue);

                            let tempDiscount2 =
                              ((parseFloat(hargaSatuan) -
                                parseFloat(discount1)) *
                                tempValue) /
                              100;
                            setDiscount2(tempDiscount2);

                            let temHargaNetto = round2(
                              parseFloat(hargaSatuan) -
                                parseFloat(discount1) -
                                parseFloat(tempDiscount2),
                            );
                            setHargaNetto(temHargaNetto);

                            let tempTotalPembelianChild = Math.ceil(
                              parseFloat(quantity) * parseFloat(temHargaNetto),
                            );
                            setTotalPembelianChild(tempTotalPembelianChild);

                            setDiscountPersen3("0");
                            setDiscount3("0");
                            setDiscountPersen4("0");
                            setDiscount4("0");
                            setDiscountPersen5("0");
                            setDiscount5("0");
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="4">
                        <NumericFormat
                          required
                          value={discount2}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onChange={(e) => {
                            let tempValue = e.target.value
                              .split(".")
                              .join("")
                              .replace(",", ".");
                            setDiscount2(tempValue);

                            let tempDiscountPersen2 =
                              (parseFloat(tempValue) /
                                (parseFloat(hargaSatuan) -
                                  parseFloat(discount1))) *
                              100;
                            // limit to 2 decimals
                            tempDiscountPersen2 = Number(
                              tempDiscountPersen2.toFixed(2),
                            );
                            setDiscountPersen2(tempDiscountPersen2);

                            let temHargaNetto = round2(
                              parseFloat(hargaSatuan) -
                                parseFloat(discount1) -
                                parseFloat(tempValue),
                            );
                            setHargaNetto(temHargaNetto);

                            let tempTotalPembelianChild = Math.ceil(
                              parseFloat(quantity) * parseFloat(temHargaNetto),
                            );
                            setTotalPembelianChild(tempTotalPembelianChild);

                            setDiscountPersen3("0");
                            setDiscount3("0");
                            setDiscountPersen4("0");
                            setDiscount4("0");
                            setDiscountPersen5("0");
                            setDiscount5("0");
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Disc / Pot. 3{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="3">
                        <NumericFormat
                          required
                          value={discountPersen3}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onChange={(e) => {
                            let tempValue = e.target.value
                              .split(".")
                              .join("")
                              .replace(",", ".");
                            setDiscountPersen3(tempValue);

                            let tempDiscount3 =
                              ((parseFloat(hargaSatuan) -
                                parseFloat(discount1) -
                                parseFloat(discount2)) *
                                tempValue) /
                              100;
                            setDiscount3(tempDiscount3);

                            let temHargaNetto = round2(
                              parseFloat(hargaSatuan) -
                                parseFloat(discount1) -
                                parseFloat(discount2) -
                                parseFloat(tempDiscount3),
                            );
                            setHargaNetto(temHargaNetto);

                            let tempTotalPembelianChild = Math.ceil(
                              parseFloat(quantity) * parseFloat(temHargaNetto),
                            );
                            setTotalPembelianChild(tempTotalPembelianChild);

                            setDiscountPersen4("0");
                            setDiscount4("0");
                            setDiscountPersen5("0");
                            setDiscount5("0");
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="4">
                        <NumericFormat
                          required
                          value={discount3}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onChange={(e) => {
                            let tempValue = e.target.value
                              .split(".")
                              .join("")
                              .replace(",", ".");
                            setDiscount3(tempValue);

                            let tempDiscountPersen3 =
                              (parseFloat(tempValue) /
                                (parseFloat(hargaSatuan) -
                                  parseFloat(discount1) -
                                  parseFloat(discount2))) *
                              100;
                            // limit to 2 decimals
                            tempDiscountPersen3 = Number(
                              tempDiscountPersen3.toFixed(2),
                            );
                            setDiscountPersen3(tempDiscountPersen3);

                            let temHargaNetto = round2(
                              parseFloat(hargaSatuan) -
                                parseFloat(discount1) -
                                parseFloat(discount2) -
                                parseFloat(tempValue),
                            );
                            setHargaNetto(temHargaNetto);

                            let tempTotalPembelianChild = Math.ceil(
                              parseFloat(quantity) * parseFloat(temHargaNetto),
                            );
                            setTotalPembelianChild(tempTotalPembelianChild);

                            setDiscountPersen4("0");
                            setDiscount4("0");
                            setDiscountPersen5("0");
                            setDiscount5("0");
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Disc / Pot. 4{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="3">
                        <NumericFormat
                          required
                          value={discountPersen4}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onChange={(e) => {
                            let tempValue = e.target.value
                              .split(".")
                              .join("")
                              .replace(",", ".");
                            setDiscountPersen4(tempValue);

                            let tempDiscount4 =
                              ((parseFloat(hargaSatuan) -
                                parseFloat(discount1) -
                                parseFloat(discount2) -
                                parseFloat(discount3)) *
                                tempValue) /
                              100;
                            setDiscount4(tempDiscount4);

                            let temHargaNetto = round2(
                              parseFloat(hargaSatuan) -
                                parseFloat(discount1) -
                                parseFloat(discount2) -
                                parseFloat(discount3) -
                                parseFloat(tempDiscount4),
                            );
                            setHargaNetto(temHargaNetto);

                            let tempTotalPembelianChild = Math.ceil(
                              parseFloat(quantity) * parseFloat(temHargaNetto),
                            );
                            setTotalPembelianChild(tempTotalPembelianChild);

                            setDiscountPersen5("0");
                            setDiscount5("0");
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="4">
                        <NumericFormat
                          required
                          value={discount4}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onChange={(e) => {
                            let tempValue = e.target.value
                              .split(".")
                              .join("")
                              .replace(",", ".");
                            setDiscount4(tempValue);

                            let tempDiscountPersen4 =
                              (parseFloat(tempValue) /
                                (parseFloat(hargaSatuan) -
                                  parseFloat(discount1) -
                                  parseFloat(discount2) -
                                  parseFloat(discount3))) *
                              100;
                            // limit to 2 decimals
                            tempDiscountPersen4 = Number(
                              tempDiscountPersen4.toFixed(2),
                            );
                            setDiscountPersen4(tempDiscountPersen4);

                            let temHargaNetto = round2(
                              parseFloat(hargaSatuan) -
                                parseFloat(discount1) -
                                parseFloat(discount2) -
                                parseFloat(discount3) -
                                parseFloat(tempValue),
                            );
                            setHargaNetto(temHargaNetto);

                            let tempTotalPembelianChild = Math.ceil(
                              parseFloat(quantity) * parseFloat(temHargaNetto),
                            );
                            setTotalPembelianChild(tempTotalPembelianChild);

                            setDiscountPersen5("0");
                            setDiscount5("0");
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Disc / Pot. 5{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="3">
                        <NumericFormat
                          required
                          value={discountPersen5}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onChange={(e) => {
                            let tempValue = e.target.value
                              .split(".")
                              .join("")
                              .replace(",", ".");
                            setDiscountPersen5(tempValue);

                            let tempDiscount5 =
                              ((parseFloat(hargaSatuan) -
                                parseFloat(discount1) -
                                parseFloat(discount2) -
                                parseFloat(discount3) -
                                parseFloat(discount4)) *
                                tempValue) /
                              100;
                            setDiscount5(tempDiscount5);

                            let temHargaNetto = round2(
                              parseFloat(hargaSatuan) -
                                parseFloat(discount1) -
                                parseFloat(discount2) -
                                parseFloat(discount3) -
                                parseFloat(discount4) -
                                parseFloat(tempDiscount5),
                            );
                            setHargaNetto(temHargaNetto);

                            let tempTotalPembelianChild = Math.ceil(
                              parseFloat(quantity) * parseFloat(temHargaNetto),
                            );
                            setTotalPembelianChild(tempTotalPembelianChild);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="4">
                        <NumericFormat
                          required
                          value={discount5}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onChange={(e) => {
                            let tempValue = e.target.value
                              .split(".")
                              .join("")
                              .replace(",", ".");
                            setDiscount5(tempValue);

                            let tempDiscountPersen5 =
                              (parseFloat(tempValue) /
                                (parseFloat(hargaSatuan) -
                                  parseFloat(discount1) -
                                  parseFloat(discount2) -
                                  parseFloat(discount3) -
                                  parseFloat(discount4))) *
                              100;
                            // limit to 2 decimals
                            tempDiscountPersen5 = Number(
                              tempDiscountPersen5.toFixed(2),
                            );
                            setDiscountPersen5(tempDiscountPersen5);

                            let temHargaNetto = round2(
                              parseFloat(hargaSatuan) -
                                parseFloat(discount1) -
                                parseFloat(discount2) -
                                parseFloat(discount3) -
                                parseFloat(discount4) -
                                parseFloat(tempValue),
                            );
                            setHargaNetto(temHargaNetto);

                            let tempTotalPembelianChild = Math.ceil(
                              parseFloat(quantity) * parseFloat(temHargaNetto),
                            );
                            setTotalPembelianChild(tempTotalPembelianChild);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Harga Netto :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={hargaNetto}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Total :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={totalPembelianChild}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>

            <Box sx={spacingTop}>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
                disabled={isInputStok === true ? false : true}
              >
                Simpan Transaksi
              </Button>
            </Box>
          </Card.Body>
        </Card>
      </Form>

      <Box sx={tableChildWrapper}>
        <TableContainer component={Paper} sx={{ width: "100%" }}>
          <Table aria-label="simple table">
            <TableHead className={classes.root}>
              <TableRow>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Kode
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Nama Stok
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Qty.
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Sat.
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Harga
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  D1 (%)
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Pot1 (Rp)
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  D2 (%)
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Pot2 (Rp)
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Total Rp.
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Aksi
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pembelianChilds.map((user, index) => (
                <TableRow
                  key={user.id}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    "&:hover": { bgcolor: Colors.grey300 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {user.stok.kodeStok}
                  </TableCell>
                  <TableCell>{user.stok.namaStok}</TableCell>
                  <TableCell align="right">
                    {user.quantity.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell>{user.stok.satuanKecilStok}</TableCell>
                  <TableCell align="right">
                    {user.hargaSatuan.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell align="right">
                    {user.discountPersen1.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell align="right">
                    {user.discount1.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell align="right">
                    {user.discountPersen2.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell align="right">
                    {user.discount2.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell align="right">
                    {user.totalPembelianChild.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell>
                    <ButtonGroup variant="contained">
                      <Button
                        sx={{ textTransform: "none" }}
                        onClick={(e) => {
                          handleClickOpenUbah(e);
                          setIdPembelianChild(user.id);
                          setKodeStok(user.stok.kodeStok);
                          setNamaStok(user.stok.namaStok);
                          setQuantityLama(user.quantity);
                          setQuantity(user.quantity);
                          setHargaSatuan(user.hargaSatuan);
                          setDiscountPersen1(user.discountPersen1);
                          setDiscount1(user.discount1);
                          setDiscountPersen2(user.discountPersen2);
                          setDiscount2(user.discount2);
                          setDiscountPersen3(user.discountPersen3);
                          setDiscount3(user.discount3);
                          setDiscountPersen4(user.discountPersen4);
                          setDiscount4(user.discount4);
                          setDiscountPersen5(user.discountPersen5);
                          setDiscount5(user.discount5);
                          setHargaNetto(user.hargaNetto);
                          setTotalPembelianChild(user.totalPembelianChild);
                        }}
                      >
                        <EditIcon />
                      </Button>
                      <Button
                        color="error"
                        sx={{ textTransform: "none" }}
                        onClick={(e) => {
                          deletePembelianChild(
                            e,
                            user.id,
                            user.quantity,
                            user.totalPembelianChild,
                          );
                        }}
                      >
                        <DeleteOutlineIcon />
                      </Button>
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Form noValidate validated={validated} onSubmit={updatePembelian}>
        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Total</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Subtotal :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={subtotal}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Potongan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={potongan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setPotongan(tempValue);

                            let tempPpnTotal = 0;

                            if (isPpn) {
                              tempPpnTotal =
                                ((parseFloat(subtotal) -
                                  parseFloat(tempValue)) *
                                  parseFloat(ppnPersen)) /
                                100;
                              setPpnTotal(tempPpnTotal);
                            } else {
                              setPpnTotal(tempPpnTotal);
                            }

                            let tempTotal =
                              parseFloat(subtotal) -
                              parseFloat(tempValue) +
                              parseFloat(tempPpnTotal);
                            setTotal(tempTotal);
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        PPN ({setting.ppnPersen}) <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="2">
                        <FormControlLabel
                          control={<Checkbox checked={isPpn} />}
                          onChange={() => {
                            setIsPpn(!isPpn);

                            if (!isPpn) {
                              setPpnPersen(setting.ppnPersen);
                              let tempPpnTotal =
                                ((parseFloat(subtotal) - parseFloat(potongan)) *
                                  parseFloat(setting.ppnPersen)) /
                                100;
                              setPpnTotal(tempPpnTotal);

                              let tempTotal =
                                parseFloat(subtotal) -
                                parseFloat(potongan) +
                                parseFloat(tempPpnTotal);
                              setTotal(tempTotal);
                            } else {
                              setPpnPersen(0);
                              setPpnTotal(0);

                              let tempTotal =
                                parseFloat(subtotal) - parseFloat(potongan);
                              setTotal(tempTotal);
                            }
                          }}
                        />
                      </Col>
                      <Col sm="5">
                        <NumericFormat
                          value={ppnTotal}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Total :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={total}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/daftarPembelian")}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            type="submit"
            disabled={id === null && true}
          >
            Simpan
          </Button>
        </Box>
      </Form>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
      <Dialog
        open={openStok}
        onClose={handleCloseStok}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Stok`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchDataStok}>
              <Box sx={searchBarContainer}>
                <SearchBar value={queryStok} setSearchTerm={setQueryStok} />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Kode
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Nama
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Satuan
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Sisa
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stoks.map((stok, index) => (
                    <TableRow
                      key={stok._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setPilihStok(stok.kodeStok);
                        setKodeStok(stok.kodeStok);
                        setNamaStok(stok.namaStok);
                        setHargaSatuan(stok.hargaSatuanStok);
                        setHargaNetto(stok.hargaSatuanStok);
                        setTotalPembelianChild(stok.hargaSatuanStok);

                        handleCloseStok();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {stok.kodeStok}
                      </TableCell>
                      <TableCell>{stok.namaStok}</TableCell>
                      <TableCell>{stok.satuanKecilStok}</TableCell>
                      <TableCell>-</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pagesStok}
                page={pageStok + 1}
                onChange={handleChangeStok}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        onClose={handleCloseUbah}
        aria-labelledby="customized-dialog-title"
        open={openUbah}
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Ubah Barang Pembelian
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseUbah}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent
          dividers
          //  sx={{ height: "200px" }}
        >
          <div>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Kode / Barcode :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control disabled value={pilihStok} />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Nama Stok :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control disabled value={namaStok} />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Quantity <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      required
                      value={quantity}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onChange={(e) => {
                        let tempValue = e.target.value
                          .split(".")
                          .join("")
                          .replace(/,/g, "");
                        setQuantity(tempValue);

                        let tempHargaNetto =
                          parseFloat(hargaSatuan) -
                          parseFloat(discount1) -
                          parseFloat(discount2);
                        setHargaNetto(tempHargaNetto);

                        let tempTotalPembelianChild = Math.ceil(
                          parseFloat(tempValue) * parseFloat(tempHargaNetto),
                        );
                        setTotalPembelianChild(tempTotalPembelianChild);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Harga Satuan <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      required
                      value={hargaSatuan}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onChange={(e) => {
                        let tempValue = e.target.value
                          .split(".")
                          .join("")
                          .replace(",", ".");
                        setHargaSatuan(tempValue);

                        let tempHargaNetto =
                          parseFloat(tempValue) -
                          parseFloat(discount1) -
                          parseFloat(discount2);
                        setHargaNetto(tempHargaNetto);

                        let tempTotalPembelianChild = Math.ceil(
                          parseFloat(quantity) * parseFloat(tempHargaNetto),
                        );
                        setTotalPembelianChild(tempTotalPembelianChild);

                        setDiscountPersen1("0");
                        setDiscount1("0");
                        setDiscountPersen2("0");
                        setDiscount2("0");
                        setDiscountPersen3("0");
                        setDiscount3("0");
                        setDiscountPersen4("0");
                        setDiscount4("0");
                        setDiscountPersen5("0");
                        setDiscount5("0");
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Disc / Pot. 1 <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="3">
                    <NumericFormat
                      required
                      value={discountPersen1}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onChange={(e) => {
                        let tempValue = e.target.value
                          .split(".")
                          .join("")
                          .replace(",", ".");
                        setDiscountPersen1(tempValue);

                        let tempDiscount1 =
                          (parseFloat(hargaSatuan) * tempValue) / 100;
                        setDiscount1(tempDiscount1);

                        let temHargaNetto = round2(
                          parseFloat(hargaSatuan) - parseFloat(tempDiscount1),
                        );
                        setHargaNetto(temHargaNetto);

                        let tempTotalPembelianChild = Math.ceil(
                          parseFloat(quantity) * parseFloat(temHargaNetto),
                        );
                        setTotalPembelianChild(tempTotalPembelianChild);

                        setDiscountPersen2("0");
                        setDiscount2("0");
                        setDiscountPersen3("0");
                        setDiscount3("0");
                        setDiscountPersen4("0");
                        setDiscount4("0");
                        setDiscountPersen5("0");
                        setDiscount5("0");
                      }}
                    />
                  </Col>
                  <Col sm="4">
                    <NumericFormat
                      required
                      value={discount1}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onChange={(e) => {
                        let tempValue = e.target.value
                          .split(".")
                          .join("")
                          .replace(",", ".");
                        setDiscount1(tempValue);

                        let tempDiscountPersen1 =
                          (parseFloat(tempValue) / parseFloat(hargaSatuan)) *
                          100;
                        // limit to 2 decimals
                        tempDiscountPersen1 = Number(
                          tempDiscountPersen1.toFixed(2),
                        );
                        setDiscountPersen1(tempDiscountPersen1);

                        let temHargaNetto = round2(
                          parseFloat(hargaSatuan) - parseFloat(tempValue),
                        );
                        setHargaNetto(temHargaNetto);

                        let tempTotalPembelianChild = Math.ceil(
                          parseFloat(quantity) * parseFloat(temHargaNetto),
                        );
                        setTotalPembelianChild(tempTotalPembelianChild);

                        setDiscountPersen2("0");
                        setDiscount2("0");
                        setDiscountPersen3("0");
                        setDiscount3("0");
                        setDiscountPersen4("0");
                        setDiscount4("0");
                        setDiscountPersen5("0");
                        setDiscount5("0");
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Disc / Pot. 2 <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="3">
                    <NumericFormat
                      required
                      value={discountPersen2}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onChange={(e) => {
                        let tempValue = e.target.value
                          .split(".")
                          .join("")
                          .replace(",", ".");
                        setDiscountPersen2(tempValue);

                        let tempDiscount2 =
                          ((parseFloat(hargaSatuan) - parseFloat(discount1)) *
                            tempValue) /
                          100;
                        setDiscount2(tempDiscount2);

                        let temHargaNetto = round2(
                          parseFloat(hargaSatuan) -
                            parseFloat(discount1) -
                            parseFloat(tempDiscount2),
                        );
                        setHargaNetto(temHargaNetto);

                        let tempTotalPembelianChild = Math.ceil(
                          parseFloat(quantity) * parseFloat(temHargaNetto),
                        );
                        setTotalPembelianChild(tempTotalPembelianChild);

                        setDiscountPersen3("0");
                        setDiscount3("0");
                        setDiscountPersen4("0");
                        setDiscount4("0");
                        setDiscountPersen5("0");
                        setDiscount5("0");
                      }}
                    />
                  </Col>
                  <Col sm="4">
                    <NumericFormat
                      required
                      value={discount2}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onChange={(e) => {
                        let tempValue = e.target.value
                          .split(".")
                          .join("")
                          .replace(",", ".");
                        setDiscount2(tempValue);

                        let tempDiscountPersen2 =
                          (parseFloat(tempValue) /
                            (parseFloat(hargaSatuan) - parseFloat(discount1))) *
                          100;
                        // limit to 2 decimals
                        tempDiscountPersen2 = Number(
                          tempDiscountPersen2.toFixed(2),
                        );
                        setDiscountPersen2(tempDiscountPersen2);

                        let temHargaNetto = round2(
                          parseFloat(hargaSatuan) -
                            parseFloat(discount1) -
                            parseFloat(tempValue),
                        );
                        setHargaNetto(temHargaNetto);

                        let tempTotalPembelianChild = Math.ceil(
                          parseFloat(quantity) * parseFloat(temHargaNetto),
                        );
                        setTotalPembelianChild(tempTotalPembelianChild);

                        setDiscountPersen3("0");
                        setDiscount3("0");
                        setDiscountPersen4("0");
                        setDiscount4("0");
                        setDiscountPersen5("0");
                        setDiscount5("0");
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Disc / Pot. 3 <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="3">
                    <NumericFormat
                      required
                      value={discountPersen3}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onChange={(e) => {
                        let tempValue = e.target.value
                          .split(".")
                          .join("")
                          .replace(",", ".");
                        setDiscountPersen3(tempValue);

                        let tempDiscount3 =
                          ((parseFloat(hargaSatuan) -
                            parseFloat(discount1) -
                            parseFloat(discount2)) *
                            tempValue) /
                          100;
                        setDiscount3(tempDiscount3);

                        let temHargaNetto = round2(
                          parseFloat(hargaSatuan) -
                            parseFloat(discount1) -
                            parseFloat(discount2) -
                            parseFloat(tempDiscount3),
                        );
                        setHargaNetto(temHargaNetto);

                        let tempTotalPembelianChild = Math.ceil(
                          parseFloat(quantity) * parseFloat(temHargaNetto),
                        );
                        setTotalPembelianChild(tempTotalPembelianChild);

                        setDiscountPersen4("0");
                        setDiscount4("0");
                        setDiscountPersen5("0");
                        setDiscount5("0");
                      }}
                    />
                  </Col>
                  <Col sm="4">
                    <NumericFormat
                      required
                      value={discount3}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onChange={(e) => {
                        let tempValue = e.target.value
                          .split(".")
                          .join("")
                          .replace(",", ".");
                        setDiscount3(tempValue);

                        let tempDiscountPersen3 =
                          (parseFloat(tempValue) /
                            (parseFloat(hargaSatuan) -
                              parseFloat(discount1) -
                              parseFloat(discount2))) *
                          100;
                        // limit to 2 decimals
                        tempDiscountPersen3 = Number(
                          tempDiscountPersen3.toFixed(2),
                        );
                        setDiscountPersen3(tempDiscountPersen3);

                        let temHargaNetto = round2(
                          parseFloat(hargaSatuan) -
                            parseFloat(discount1) -
                            parseFloat(discount2) -
                            parseFloat(tempValue),
                        );
                        setHargaNetto(temHargaNetto);

                        let tempTotalPembelianChild = Math.ceil(
                          parseFloat(quantity) * parseFloat(temHargaNetto),
                        );
                        setTotalPembelianChild(tempTotalPembelianChild);

                        setDiscountPersen4("0");
                        setDiscount4("0");
                        setDiscountPersen5("0");
                        setDiscount5("0");
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Disc / Pot. 4 <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="3">
                    <NumericFormat
                      required
                      value={discountPersen4}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onChange={(e) => {
                        let tempValue = e.target.value
                          .split(".")
                          .join("")
                          .replace(",", ".");
                        setDiscountPersen4(tempValue);

                        let tempDiscount4 =
                          ((parseFloat(hargaSatuan) -
                            parseFloat(discount1) -
                            parseFloat(discount2) -
                            parseFloat(discount3)) *
                            tempValue) /
                          100;
                        setDiscount4(tempDiscount4);

                        let temHargaNetto = round2(
                          parseFloat(hargaSatuan) -
                            parseFloat(discount1) -
                            parseFloat(discount2) -
                            parseFloat(discount3) -
                            parseFloat(tempDiscount4),
                        );
                        setHargaNetto(temHargaNetto);

                        let tempTotalPembelianChild = Math.ceil(
                          parseFloat(quantity) * parseFloat(temHargaNetto),
                        );
                        setTotalPembelianChild(tempTotalPembelianChild);

                        setDiscountPersen5("0");
                        setDiscount5("0");
                      }}
                    />
                  </Col>
                  <Col sm="4">
                    <NumericFormat
                      required
                      value={discount4}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onChange={(e) => {
                        let tempValue = e.target.value
                          .split(".")
                          .join("")
                          .replace(",", ".");
                        setDiscount4(tempValue);

                        let tempDiscountPersen4 =
                          (parseFloat(tempValue) /
                            (parseFloat(hargaSatuan) -
                              parseFloat(discount1) -
                              parseFloat(discount2) -
                              parseFloat(discount3))) *
                          100;
                        // limit to 2 decimals
                        tempDiscountPersen4 = Number(
                          tempDiscountPersen4.toFixed(2),
                        );
                        setDiscountPersen4(tempDiscountPersen4);

                        let temHargaNetto = round2(
                          parseFloat(hargaSatuan) -
                            parseFloat(discount1) -
                            parseFloat(discount2) -
                            parseFloat(discount3) -
                            parseFloat(tempValue),
                        );
                        setHargaNetto(temHargaNetto);

                        let tempTotalPembelianChild = Math.ceil(
                          parseFloat(quantity) * parseFloat(temHargaNetto),
                        );
                        setTotalPembelianChild(tempTotalPembelianChild);

                        setDiscountPersen5("0");
                        setDiscount5("0");
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Disc / Pot. 5 <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="3">
                    <NumericFormat
                      required
                      value={discountPersen5}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onChange={(e) => {
                        let tempValue = e.target.value
                          .split(".")
                          .join("")
                          .replace(",", ".");
                        setDiscountPersen5(tempValue);

                        let tempDiscount5 =
                          ((parseFloat(hargaSatuan) -
                            parseFloat(discount1) -
                            parseFloat(discount2) -
                            parseFloat(discount3) -
                            parseFloat(discount4)) *
                            tempValue) /
                          100;
                        setDiscount5(tempDiscount5);

                        let temHargaNetto = round2(
                          parseFloat(hargaSatuan) -
                            parseFloat(discount1) -
                            parseFloat(discount2) -
                            parseFloat(discount3) -
                            parseFloat(discount4) -
                            parseFloat(tempDiscount5),
                        );
                        setHargaNetto(temHargaNetto);

                        let tempTotalPembelianChild = Math.ceil(
                          parseFloat(quantity) * parseFloat(temHargaNetto),
                        );
                        setTotalPembelianChild(tempTotalPembelianChild);
                      }}
                    />
                  </Col>
                  <Col sm="4">
                    <NumericFormat
                      required
                      value={discount5}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onChange={(e) => {
                        let tempValue = e.target.value
                          .split(".")
                          .join("")
                          .replace(",", ".");
                        setDiscount5(tempValue);

                        let tempDiscountPersen5 =
                          (parseFloat(tempValue) /
                            (parseFloat(hargaSatuan) -
                              parseFloat(discount1) -
                              parseFloat(discount2) -
                              parseFloat(discount3) -
                              parseFloat(discount4))) *
                          100;
                        // limit to 2 decimals
                        tempDiscountPersen5 = Number(
                          tempDiscountPersen5.toFixed(2),
                        );
                        setDiscountPersen5(tempDiscountPersen5);

                        let temHargaNetto = round2(
                          parseFloat(hargaSatuan) -
                            parseFloat(discount1) -
                            parseFloat(discount2) -
                            parseFloat(discount3) -
                            parseFloat(discount4) -
                            parseFloat(tempValue),
                        );
                        setHargaNetto(temHargaNetto);

                        let tempTotalPembelianChild = Math.ceil(
                          parseFloat(quantity) * parseFloat(temHargaNetto),
                        );
                        setTotalPembelianChild(tempTotalPembelianChild);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Harga Netto :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      disabled
                      value={hargaNetto}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Total :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      disabled
                      value={totalPembelianChild}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={updatePembelianChild}
          >
            Simpan
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default UbahPembelian;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "800px",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const colorRed = {
  color: "red",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const tableChildWrapper = {
  mt: 4,
  height: "400px",
  overflowY: "auto",
  border: "1px solid #e0e0e0",
};
